import { gql } from '@apollo/client'

import { viewFragment } from 'js/magazine/lib/fragments'

export const MAGAZINE_VIEW = gql`
    query MagazineView($guid: String!) {
        entity(guid: $guid, incrementViewCount: true) {
            guid
            ${viewFragment}
        }
    }
`
